import React from "react";
import styles from "./SummaryAttribute.module.css";
import "font-awesome/css/font-awesome.css";
import FontAwesome from "react-fontawesome";
import Avatar from "components/User/Avatar";

import { type SummaryAttributeValuePrincipal } from "data/types";

const ValueUser = ({ value }: { value: SummaryAttributeValuePrincipal }) => {
    const renderName = () => (
        <>
            <span className={styles.userText}>
                <FontAwesome name="envelope-o" /> {value.displayName}
                <br />
                {value.description}
            </span>
            <Avatar id={value.id} className={styles.avatar} />
        </>
    );

    if (value.displayName == null) return null;
    if (value.email == null) return renderName();

    return (
        <a
            className={styles.user}
            href={`mailto:${value.email}`}
            rel="noopener external noreferrer"
            target="_blank"
            title={`email ${value.displayName}`}
        >
            {renderName()}
        </a>
    );
};
ValueUser.displayName = "AttributeSummaryValue.User";
export default ValueUser;
